<template>
  <div class="table-responsive" style="overflow: unset" v-if="userEditing.user_preference_attributes">
    <table class="table table-hover-pink">
      <thead>
        <tr>
          <th class="text-black">{{ $t('UserNoticePreferences.contact_me_when') }}</th>
          <th class="text-black label-notice-preference">{{ $t('UserNoticePreferences.by_email') }}</th>
          <th class="text-black label-notice-preference">{{ $t('UserNoticePreferences.by_mobile_notification') }}</th>
          <th class="text-black label-notice-preference" v-if="isAcceptSms">{{ $t('UserNoticePreferences.by_sms') }}</th>
        </tr>
      </thead>
      <tbody>
        <select-entity v-if="needEntitySelect"
                       :entities="entities"
                       v-on:entity-changed="onChangeEntity"
                       colLabel="col-md-6"
                       colSelect="col-md-6"
                       class="select-entity"></select-entity>
                       <notice-preferences-row v-for="event in noticeEvents" :key="event.name" :event="event" :userEditing="userEditing" :entityAcceptSms="entityAcceptSms"/>
                       <notice-preferences-with-services-row v-if="showEntity"
                                                             v-for="notice in noticeServicesEvents"
                                                             :key="notice.name" :notice="notice"
                                                             :currentUser="currentUser"
                                                             :entity="entity"/>
      </tbody>
    </table>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { roleAdmins } from '@/settings/roles'
  import NoticePreferencesRow from './NoticePreferencesRow'
  import NoticePreferencesWithServicesRow from './NoticePreferencesWithServicesRow'
  import SelectEntity from '../common/SelectEntity'

  export default {
    name: 'UserNoticePreferences',
    props: ['userEditing', 'entityAcceptSms'],
    components: {
      NoticePreferencesRow, NoticePreferencesWithServicesRow, SelectEntity
    },
    data() {
      return {
        entity: null,
        showEntity: false
      }
    },
    computed: {
      ...mapGetters({
        currentUser: 'auth/currentUser',
        entities: 'auth/entities'
      }),
      isAcceptSms() {
        return this.entityAcceptSms && this.userEditing.user_preference_attributes.accept_sms
      },
      noticeServicesEvents() {
        if (roleAdmins.includes(this.currentUser.role) || this.currentUser.role == "recruiter") {
          return [
            { name: 'candidates_apply_other_service',   title: this.$i18n.t('UserNoticePreferences.candidates_apply_other_service') },
            { name: 'candidates_validates_other_service', title: this.$i18n.t('UserNoticePreferences.candidates_validates_other_service') },
            { name: 'recruiter_offer_cancelled_in_service', title: this.$i18n.t('UserNoticePreferences.recruiter_offer_cancelled_in_service') }
          ]
        }
      },
      noticeEvents() {
        if (roleAdmins.includes(this.currentUser.role)) {
          return this.adminOptions
        } else if (this.currentUser.role == "recruiter") {
          return this.recruiterOptions
        }
        return this.candidateOptions
      },
      adminOptions() {
        return [
          { name: 'recruiter_application_waiting',   title: this.$i18n.t('UserNoticePreferences.recruiter_application_waiting') },
          { name: 'recruiter_validate_subscription', title: this.$i18n.t('UserNoticePreferences.recruiter_validate_subscription') }
        ]
      },
      recruiterOptions() {
        return [
          { name: 'recruiter_application_waiting',   title: this.$i18n.t('UserNoticePreferences.recruiter_application_waiting') },
        ]
      },
      candidateOptions() {
        return [
          { name: 'candidate_interresting_offer',   title: this.$i18n.t('UserNoticePreferences.candidate_interresting_offer') },
          { name: 'candidate_application_accepted', title: this.$i18n.t('UserNoticePreferences.candidate_application_accepted') },
          { name: 'candidate_application_refused',  title: this.$i18n.t('UserNoticePreferences.candidate_application_refused') },
          { name: 'candidate_cancel_offer',         title: this.$i18n.t('UserNoticePreferences.candidate_cancel_offer') }
        ]
      },
      needEntitySelect() {
        const result = this.entities.length > 1

        if (!result) {
          this.entity = this.entities[0]
          this.showEntity = true
        }

        return result
      }
    },
    methods: {
      onChangeEntity(value) {
        this.showEntity = true
        this.entity = value
      }
    }
  }
</script>

<style type="text/css">
  .label-notice-preference {
    width: 20%;
    text-align: center;
  }

  .select-entity {
    padding: 1px 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/users/UserNoticePreferences.vue